<template>
  <div class="breadcrumb">
    <div class="breadcrumb-page">当前位置:</div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in titleList"
        :key="index"
      ><a v-if="item.src" @click="$router.push({path:item.src})
    ">{{item.name||''}}</a><span v-else>{{item.name||''}}</span></el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  props: {
    titleList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  position: fixed;
  font-size: 14px;
  color: #9b9b9b;
  display: flex;
  height: 47px;
  background: #ffffff;
  width: 100%;
  align-items: center;
  border: 1px solid rgba(230, 227, 227, 1);
  padding-left: 30px;
  z-index: 1000;
  .breadcrumb-page {
    line-height: 1;
    margin-right: 5px;
  }
}
</style>

